/**
 * Format a Date object as HH:MM:SS
 * @param {Date} date - The date to format
 * @returns {string} Formatted time string
 */
function formatTimeNow(date) {
  return ((date.getHours() < 10) ? "0" : "") + date.getHours() + ":" +
    ((date.getMinutes() < 10) ? "0" : "") + date.getMinutes() + ":" +
    ((date.getSeconds() < 10) ? "0" : "") + date.getSeconds();
}

window.pm_ajax_request_active = 0;
window.messages_highlighted = 1;
window.last_ads_reload = new Date().getTime();
// Avoid multiple calls of load more threads called by scroll
window.load_more_threads_active = 0;
// Avoid multiple calls of load_more_msg
window.load_more_msg_active = 0;
// Array of drafts
window.last_draft = {};
// Track if user is currently swiping/dragging on mobile
window.isDragging = false;

// Local draft persistence — survives page refresh
const DRAFT_STORAGE_KEY = 'pm_drafts';

window.draftStorage = {
  // Empty string sentinel means "user cleared the draft" vs key missing means "no local data"
  save(threadId, text) {
    if (!threadId) return;
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
      drafts[threadId] = text || '';
      localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(drafts));
    } catch { /* quota exceeded or private browsing */ }
  },
  load(threadId) {
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
      return threadId in drafts ? drafts[threadId] : null;
    } catch { return null; }
  },
  remove(threadId) {
    if (!threadId) return;
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
      delete drafts[threadId];
      localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(drafts));
    } catch { /* ignore */ }
  }
};

const err_div = $("<div style=\"color:red\"></div>");
const err_txt = "Error during processing, please reload page and try again.";

const isMarkitUpLoaded = function() {
  return typeof $.markItUp === "function";
};

window.append_msgs = function(msg_data, target) {
  let msgs_jq = jQuery(msg_data);

  // Remove previous "last online" blurbs
  $("div.msg_last_online").remove();
  
  // Collapse messages from same user
  let last_user = $("#threads_right").find(".msg_username:last").text();
  if (last_user === msgs_jq.find(".msg_username:first").text()) {
    msgs_jq.find(".msg_meta_wrapper:first").remove();
  }

  target.append(msgs_jq);
  
  // If conversation empty, remove no_messages indicator
  if (target.find(".no_messages").length) {
    target.find(".no_messages").remove();
  }
  
  // Scroll to bottom after appending new messages
  window.setTimeout(function() {
    if (typeof target.scrollTo === "function" && target.length) {
      target.scrollTo({
        top: target.get(0).scrollHeight,
        left: 0,
        behavior: "smooth"
      });
    }
  }, 100);
};

// Onload
$(document).ready(function() {
  if ($(".privateMessages").length === 0) {
    return;
  }
  pm_ajax_request_active = 0;
  messages_highlighted = 1;
  last_ads_reload = new Date().getTime();
  // Avoid multiple calls of load more threads called by scroll
  load_more_threads_active = 0;
  // Avoid multiple calls of load_more_msg
  load_more_msg_active = 0;
  // Array of drafts
  last_draft = {};
  // Initialize dragging state
  window.isDragging = false;

  // Only autofocus on desktop to avoid opening virtual keyboard on mobile
  if (window.matchMedia('(min-width: 640px)').matches) {
    $("#message").focus();
  }

  // Restore local draft, overriding stale server-rendered draft
  var initialThreadId = $("#send_thread_id").val();
  if (initialThreadId) {
    var localDraft = window.draftStorage.load(initialThreadId);
    var serverDraft = $("#message").val()?.trim() || '';
    if (localDraft !== null && localDraft !== serverDraft) {
      $("#message").val(localDraft);
      if (localDraft) {
        $("#threads_main").addClass("send");
      } else {
        $("#threads_main").removeClass("send");
      }
    }
  }

  // Detect view mode
  window.pm_view_mode = $("#threads_main").hasClass("paged") || $("#single_thread_wrapper").length ? "paged" : "chat";

  if (pm_view_mode === "paged") {
    // Load thread on click
    $(document).on("click", ".pm_thread", function(e) {
      // Do not run when clicked on buttons
      if ($(e.target).hasClass("fa")) return false;
      if ($(e.target).hasClass("thumb")) return true;

      // Get thread ID
      var id = $(this).attr("id").replace("thread_", "");

      window.location.href = window.location.protocol + "//" +
        window.location.hostname + window.location.pathname +
        "?thread_id=" + id;
      return false;
    });

    // Remove highlighting from new messages in 3s
    window.setTimeout(function() {
      window.remove_new_mark();
    }, 3000);

    // If user push back btn in classic view after using split view
    if (htm5_history_supported) {
      // Listen to htm5 history events
      window.addEventListener("popstate", function(e) {
        if (e.state) {
          // Redirect to url in path (simulate browser history)
          let loc = window.location.protocol + "//" +
            window.location.hostname + window.location.pathname;
          if (typeof e.state.thread_id != "undefined" && !isNaN(e.state.thread_id) &&
            (e.state.thread_id != "")) {
            loc += "?thread_id=" + e.state.thread_id;
          }
          window.location.href = loc;
        }
        return false;
      }, false);
    }
  }

  // Run filter by username on enter
  $(document).on("keyup", "#username_filter", function(e) {
    if (e.keyCode === 13) {
      window.find_contact();
    }
  });

  // Run add contact on enter
  $(document).on("keyup", "#new_contact", function(e) {
    if (e.keyCode === 13) {
      window.add_contact();
    }
  });

  // Regular updates
  window.run_update_process();

  // Chat view mode related functions
  if (pm_view_mode === "chat") {
    // Load more messages on scroll up or "Load more" link click
    $("#threads_right").scroll(function() {
      // Avoid multiple calls
      if (load_more_msg_active == 1) return;
      if ($(this).scrollTop() === 0) window.load_more_msg();
    });
    $(document).on("click", "#load_older_messages", window.load_more_msg);

    // Remove "new" in 3 seconds
    window.setTimeout(function() {
      window.remove_new_mark();
    }, 3000);

    // Load thread on click
    $(document).on("click", ".pm_thread", function(e) {
      // Do not run when clicked on buttons, icons, or thumbnails
      if ($(e.target).hasClass("fa")) return false;
      if ($(e.target).hasClass("thumb")) return true;
      if ($(e.target).is("button")) return false;
      if ($(e.target).closest("button").length) return false;
      if ($(e.target).closest(".thread-swipe-actions").length) return false;
      if ($(e.target).closest(".thread-desktop-actions").length) return false;

      // Don't open thread if user was swiping
      if (window.isDragging) return false;

      e.preventDefault();

      // Get thread ID
      let id = $(this).attr("id").replace("thread_", "");

      // If html5 history not supported use redirect
      if (!htm5_history_supported) {
        window.location.href = window.location.protocol + "//" +
          window.location.hostname + window.location.pathname +
          "?thread_id=" + id;
        return false;
      }

      // Push url to html5 history
      let stateObj = { "thread_id": id };
      history.pushState(stateObj, null, "/pm.php?thread_id=" + id);

      window.view_thread(id, true);
    });

    if (htm5_history_supported) {
      // Listen to htm5 history events
      window.addEventListener("popstate", function(e) {
        // Jump to thread in path (simulate browser history)
        if (e.state) {
          if (typeof e.state.thread_id != "undefined" && !isNaN(e.state.thread_id) &&
            (e.state.thread_id != "")) {
            window.view_thread(e.state.thread_id, true);
            return false;
          }
        }
        window.close_thread(true);

        return false;
      }, false);
    }

    // Load older conversations on scroll down + persist scroll position
    $("#threads_left").scroll(function() {
      // Save scroll position for restoration after reloads/reflows
      try { sessionStorage.setItem('pm_threads_scroll', this.scrollTop); } catch(e) {}

      // If no btn - return
      if (load_more_threads_active == 1 || $("#load_more_conversations").length == 0) return;
      let cont = $(this);

      // Check if we're near the bottom (within 150px)
      const scrollPosition = cont.scrollTop() + cont.innerHeight();
      const scrollHeight = this.scrollHeight;
      const scrollThreshold = 150; // pixels from bottom

      if (scrollPosition + scrollThreshold >= scrollHeight) {
        // We're near the bottom, load more threads
        window.load_older_conversations(false);
      }
    });

    // Resize to fit screen
    // window.threads_main_resize();

    if (!is_mobile_browser()) {
      // Detect resize end and run resize func
      let rtime = new Date(1, 1, 2000, 12, 0, 0);
      let timeout = false;
      let delta = 500;
      $(window).resize(function() {
        rtime = new Date();
        if (timeout === false) {
          timeout = true;
          setTimeout(window.resizeend, delta);
        }
      });

      window.resizeend = function() {
        if (new Date() - rtime < delta) {
          setTimeout(window.resizeend, delta);
        } else {
          timeout = false;
          // window.threads_main_resize();
        }
      };
    }

    // If opening active thread by direct link
    let activeThread = $("#threads_left .pm_thread.active");
    if (activeThread.length) {
      // Restore saved scroll position, or scroll active thread into view
      var savedScroll = null;
      try { savedScroll = sessionStorage.getItem('pm_threads_scroll'); } catch(e) {}
      var restoreTarget = savedScroll !== null ? parseInt(savedScroll, 10) : null;
      var tlEl = document.getElementById('threads_left');
      if (restoreTarget !== null) {
        tlEl.scrollTop = restoreTarget;
        setTimeout(function() { tlEl.scrollTop = restoreTarget; }, 0);
        setTimeout(function() { tlEl.scrollTop = restoreTarget; }, 50);
        setTimeout(function() { tlEl.scrollTop = restoreTarget; }, 200);
      } else {
        window.scroll_thread_to_middle(activeThread);
      }
      window.open_active_thread_by_link(activeThread);
    }

  } // Chat view related functions END

  // Resize message input textarea to fit content
  const MAX_TEXTAREA_HEIGHT = 128;

  function autoResizeTextarea() {
    const el = this;

    // Reset height to 0 so scrollHeight reflects actual content size
    el.style.height = '0';
    var baseHeight = el.scrollHeight;

    if (baseHeight > MAX_TEXTAREA_HEIGHT) {
      el.style.height = MAX_TEXTAREA_HEIGHT + 'px';
      el.style.overflowY = 'auto';
    } else {
      el.style.height = baseHeight + 'px';
      el.style.overflowY = 'hidden';
    }

    // Keep messages scrolled to bottom when textarea resizes
    var threadsRight = document.getElementById('threads_right');
    if (threadsRight) {
      threadsRight.scrollTop = threadsRight.scrollHeight;
    }
  }

  $("#message").on("input", autoResizeTextarea);

  // Resize textarea on load if it already has content (e.g. server-rendered draft)
  var msgEl = document.getElementById('message');
  if (msgEl && msgEl.value.length > 0) {
    autoResizeTextarea.call(msgEl);
  }

  // Send message when pressing enter on desktop; on mobile, Enter inserts newline
  $("#message").on("keydown", function(e) {
    if (e.key === "Enter" && !e.shiftKey && window.matchMedia('(min-width: 640px)').matches) {
      e.preventDefault();
      $("#msg_submit").click();
    }
  });

  // Mobile keyboard handling: hide bottom nav and resize PM container to visual viewport
  if (window.matchMedia('(max-width: 639px)').matches) {
    var pmContainer = document.querySelector('.privateMessages');
    var keyboardTimer = null;
    var isKeyboardOpen = false;

    function updatePmContainerHeight() {
      if (!isKeyboardOpen || !pmContainer) return;
      var vv = window.visualViewport;
      if (vv) {
        pmContainer.style.setProperty('height', vv.height + 'px', 'important');
        pmContainer.style.setProperty('top', vv.offsetTop + 'px', 'important');
        scrollMessagesToBottom();
      }
    }

    function scrollMessagesToBottom() {
      var threadsRight = document.getElementById('threads_right');
      if (threadsRight) {
        threadsRight.scrollTop = threadsRight.scrollHeight;
      }
    }

    function openKeyboard() {
      isKeyboardOpen = true;
      pmContainer.classList.add('keyboard-open');
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updatePmContainerHeight);
        window.visualViewport.addEventListener('scroll', updatePmContainerHeight);
      }
      // Defer layout changes so they don't interfere with iOS focus/caret rendering
      requestAnimationFrame(function() {
        updatePmContainerHeight();
        scrollMessagesToBottom();
        setTimeout(scrollMessagesToBottom, 300);
      });
    }

    function closeKeyboard() {
      isKeyboardOpen = false;
      pmContainer.classList.remove('keyboard-open');
      pmContainer.style.removeProperty('height');
      pmContainer.style.removeProperty('top');
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', updatePmContainerHeight);
        window.visualViewport.removeEventListener('scroll', updatePmContainerHeight);
      }
      // Re-run resize after iOS keyboard dismiss animation finishes so
      // visualViewport.height reflects the full viewport, not the
      // stale keyboard-reduced value.
      setTimeout(function() { window.threads_main_resize(); }, 400);
    }

    if (pmContainer) {
      document.addEventListener('focusin', function(e) {
        if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT') {
          clearTimeout(keyboardTimer);
          openKeyboard();
        }
      });

      document.addEventListener('focusout', function(e) {
        if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT') {
          keyboardTimer = setTimeout(function() {
            closeKeyboard();
          }, 100);
        }
      });
    }
  }

  // Update send button state based on message content and photo
  function updateSendButtonState() {
    const $submitBtn = $("#msg_submit");
    const messageText = $("#message").val()?.trim() || '';
    const hasPhotoSelected = window.photoUpload && window.photoUpload.hasPhoto();
    const hasAudioReady = window.audioRecord && window.audioRecord.hasAudio();
    const hasContent = messageText.length > 0 || hasPhotoSelected || hasAudioReady;

    $submitBtn.prop("disabled", !hasContent);

    // Also toggle classes for visual state
    if (hasContent) {
      $submitBtn.removeClass("bg-gray-200 text-gray-400").addClass("bg-sky-500 text-white");
    } else {
      $submitBtn.removeClass("bg-sky-500 text-white").addClass("bg-gray-200 text-gray-400");
    }

    // Hide mic button when typing (can't send text + audio in same message)
    const $micBtn = $("#mic_btn");
    if ($micBtn.length) {
      $micBtn.toggleClass('hidden', messageText.length > 0);
    }
  }

  // Update button state on input changes and persist draft locally
  $("#message").on("input", function () {
    updateSendButtonState();
    const threadId = $("#send_thread_id").val();
    window.draftStorage.save(threadId, $(this).val().trim());
  });

  // Expose function globally for photo upload module to call after selecting/removing photos
  window.updateSendButtonState = updateSendButtonState;

  // Initial state check
  updateSendButtonState();
  
  // Device detection - determine if we should use swipe or dropdown interface
  const isTouchDevice = () => {
    return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
  };
  
  const isMobileDevice = () => {
    // Check if the is_mobile_browser function exists and use it for consistency
    if (typeof is_mobile_browser === 'function') {
      return is_mobile_browser();
    }
    // Fallback to user agent detection
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (
      /android/i.test(userAgent) ||
      /iPad|iPhone|iPod/.test(userAgent) ||
      /windows phone/i.test(userAgent) ||
      /mobile/i.test(userAgent)
    );
  };
  
  // Determine interface type: use swipe for mobile devices or touch devices with small screens
  const shouldUseSwipeInterface = () => {
    return isMobileDevice() || (isTouchDevice() && window.innerWidth < 768);
  };
  
  // Initialize interface based on device type
  const initializeThreadActions = () => {
    if (shouldUseSwipeInterface()) {
      // Show swipe interface, hide dropdown interface
      $('.thread-desktop-actions').addClass('hidden');
      $('.thread-swipe-actions').removeClass('hidden');
      $('.thread-swipe-actions').each(function() {
        window.LucideIcons && window.LucideIcons.initialize(this);
      });
    } else {
      // Show dropdown interface, hide swipe interface
      $('.thread-desktop-actions').removeClass('hidden');
      $('.thread-swipe-actions').addClass('hidden');
    }
  };
  
  // Initialize on load
  initializeThreadActions();
  
  // Debounced resize handler to avoid performance issues
  let resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initializeThreadActions, 150);
  });
  
  // Toggle the compact filter dropdown
  $("#filters-compact-toggle").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    $("#pm-options-menu").addClass("hidden");
    $("#conversation-actions-menu").addClass("hidden");
    $(".thread-actions-menu").addClass("hidden");
    var menu = $("#filters-compact-menu");
    menu.toggleClass("hidden");
    if (!menu.hasClass("hidden")) {
      window.LucideIcons && window.LucideIcons.initialize(menu[0]);
    }
  });

  // Toggle the options menu
  $("#pm-options-toggle").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    // Close other menus first
    $("#filters-compact-menu").addClass("hidden");
    $("#conversation-actions-menu").addClass("hidden");
    $(".thread-actions-menu").addClass("hidden");
    $("#pm-options-menu").toggleClass("hidden");
  });
  
  // Toggle the conversation actions menu
  $("#conversation-actions-toggle").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    // Close other menus first
    $("#filters-compact-menu").addClass("hidden");
    $("#pm-options-menu").addClass("hidden");
    $(".thread-actions-menu").addClass("hidden");
    $("#conversation-actions-menu").toggleClass("hidden");
  });
  
  // Close menus when clicking outside
  $(document).on("click", function(e) {
    if (!$(e.target).closest("#filters-compact-toggle, #filters-compact-menu").length) {
      $("#filters-compact-menu").addClass("hidden");
    }
    if (!$(e.target).closest("#pm-options-toggle, #pm-options-menu").length) {
      $("#pm-options-menu").addClass("hidden");
    }
    if (!$(e.target).closest("#conversation-actions-toggle, #conversation-actions-menu").length) {
      $("#conversation-actions-menu").addClass("hidden");
    }
    if (!$(e.target).closest(".thread-actions-toggle, .thread-actions-menu").length) {
      $(".thread-actions-menu").addClass("hidden");
    }
    // Close message action menus when clicking outside
    if (!$(e.target).closest(".msg-actions-toggle, .msg-actions-menu").length) {
      $(".msg-actions-menu").addClass("hidden");
    }
  });
  
  // Prevent menu from closing when clicking inside it
  $("#pm-options-menu, #conversation-actions-menu").on('click', function(e) {
    if (!$(e.target).is('a')) {
      e.stopPropagation();
    }
  });
  
  // Handle thread-level action dropdowns (desktop only)
  $(document).on("click", ".thread-actions-toggle", function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Close all other menus first
    $("#filters-compact-menu").addClass("hidden");
    $("#pm-options-menu").addClass("hidden");
    $("#conversation-actions-menu").addClass("hidden");
    $(".thread-actions-menu").addClass("hidden");
    
    // Position and show this specific menu
    const $menu = $(this).next(".thread-actions-menu");
    const $button = $(this);
    
    // Calculate positioning to avoid viewport edges
    const buttonRect = $button[0].getBoundingClientRect();
    const menuWidth = 192; // w-48 = 12rem = 192px
    const menuHeight = 96; // approximate height for 2 items
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    let left = buttonRect.right - menuWidth;
    let top = buttonRect.bottom + 8;
    
    // Adjust horizontal position if too close to left edge
    if (left < 8) {
      left = buttonRect.left;
    }
    
    // Adjust vertical position if too close to bottom edge
    if (top + menuHeight > viewportHeight - 8) {
      top = buttonRect.top - menuHeight - 8;
    }
    
    // Position the menu
    $menu.css({
      left: left + 'px',
      top: top + 'px'
    }).removeClass("hidden");
  });
  
  // Prevent thread action menu from closing when clicking inside it
  $(document).on('click', '.thread-actions-menu', function(e) {
    if (!$(e.target).is('a')) {
      e.stopPropagation();
    }
  });

  // Mobile swipe functionality
  let touchStartX = 0;
  let touchStartY = 0;
  let currentSwipeThread = null;

  // Touch start handler
  $(document).on('touchstart', '.pm_thread', function(e) {
    if (!shouldUseSwipeInterface()) return; // Only for swipe interface
    
    const touch = e.originalEvent.touches[0];
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    window.isDragging = false;
    currentSwipeThread = $(this);
    
    // Reset any other swiped threads
    $('.thread-swipe-actions').removeClass('translate-x-0').addClass('translate-x-full');
  });

  // Touch move handler
  $(document).on('touchmove', '.pm_thread', function(e) {
    if (!shouldUseSwipeInterface() || !currentSwipeThread || !currentSwipeThread.is($(this))) return;
    
    const touch = e.originalEvent.touches[0];
    const deltaX = touchStartX - touch.clientX;
    const deltaY = Math.abs(touchStartY - touch.clientY);
    
    // Only consider horizontal swipes
    if (deltaY > 30) return;
    
    if (Math.abs(deltaX) > 10) {
      window.isDragging = true;
      e.preventDefault();
      
      const $actions = $(this).find('.thread-swipe-actions');
      
      if (deltaX > 30) {
        // Swiping left - show actions
        $actions.removeClass('translate-x-full').addClass('translate-x-0');
      } else if (deltaX < -10) {
        // Swiping right - hide actions
        $actions.removeClass('translate-x-0').addClass('translate-x-full');
      }
    }
  });

  // Touch end handler
  $(document).on('touchend', '.pm_thread', function(e) {
    if (!shouldUseSwipeInterface()) return;
    
    setTimeout(() => {
      window.isDragging = false;
      currentSwipeThread = null;
    }, 100);
  });

  // Close swipe actions when touching elsewhere
  $(document).on('touchstart', function(e) {
    if (!shouldUseSwipeInterface()) return;
    
    // Don't close if touching within a thread OR within swipe action buttons
    if (!$(e.target).closest('.pm_thread').length && !$(e.target).closest('.thread-swipe-actions').length) {
      $('.thread-swipe-actions').removeClass('translate-x-0').addClass('translate-x-full');
    }
  });
  
  // Handle swipe action button interactions
  let swipeActionHandled = false;
  
  // Handle touch events for swipe action buttons (mobile primary)
  $(document).on('touchstart', '.thread-swipe-actions button', function(e) {
    swipeActionHandled = false;
  });
  
  $(document).on('touchend', '.thread-swipe-actions button', function(e) {
    if (swipeActionHandled) return false;
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    swipeActionHandled = true;
    
    const $button = $(this);
    const $thread = $button.closest('.pm_thread');
    const threadId = $thread.data('thread-id');
    const isBlockAction = $button.find('[data-lucide="ban"]').length > 0;

    if (threadId) {
      window.delete_thread(this, threadId, isBlockAction ? 1 : 0);
    }

    return false;
  });

  // Handle click events for swipe action buttons (desktop fallback)
  $(document).on('click', '.thread-swipe-actions button', function(e) {
    if (swipeActionHandled) {
      swipeActionHandled = false;
      return false;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const $button = $(this);
    const $thread = $button.closest('.pm_thread');
    const threadId = $thread.data('thread-id');
    const isBlockAction = $button.find('[data-lucide="ban"]').length > 0;

    if (threadId) {
      window.delete_thread(this, threadId, isBlockAction ? 1 : 0);
    }

    return false;
  });

  // Handle desktop action button clicks with proper event handling
  $(document).on('click', '.thread-actions-menu a', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const $link = $(this);
    const $thread = $link.closest('.pm_thread');
    const threadId = $thread.data('thread-id');
    const isBlockAction = $link.find('[data-lucide="ban"]').length > 0;
    
    // Close the dropdown menu after click
    $link.closest('.thread-actions-menu').addClass('hidden');
    
    if (threadId) {
      window.delete_thread(this, threadId, isBlockAction ? 1 : 0);
    }
    
    return false;
  });
  
  // Initialize draggable separator
  initDraggableSeparator();
  
  // Call resize on initial load and after a short delay to ensure all elements are properly loaded
  window.threads_main_resize();
  setTimeout(window.threads_main_resize, 200);

  // Add a debounced resize handler to maintain correct sizing
  $(window).on('resize', function() {
    clearTimeout(window.resizeTimer);
    window.resizeTimer = setTimeout(function() {
      window.threads_main_resize();
    }, 250);
  });

  // Initialize photo upload and message sender modules
  // These are now loaded from separate files for better organization
});

// Photo upload and message sending functionality is now modularized
// into separate files: photo-upload.js and message-sender.js

// Initialize draggable separator between thread list and messages
function initDraggableSeparator() {
  const separator = document.getElementById('separator');
  const leftPane = document.getElementById('threads_left_container');
  const rightPane = document.getElementById('threads-right__container');
  
  if (!separator || !leftPane || !rightPane) {
    return; // Elements not found, skip initialization
  }
  
  let isResizing = false;
  let startX = 0;
  let startLeftWidth = 0;
  
  const MIN_LEFT_WIDTH = 280;
  const MAX_LEFT_WIDTH = 800;
  const MIN_RIGHT_WIDTH = 450;
  
  // Save width to localStorage
  function saveLeftPaneWidth(width) {
    try {
      localStorage.setItem('messages-left-pane-width', width);
    } catch (e) {
      // Ignore localStorage errors
    }
  }
  
  // Load width from localStorage (returns null if not set)
  function loadLeftPaneWidth() {
    try {
      const savedWidth = localStorage.getItem('messages-left-pane-width');
      return savedWidth ? parseInt(savedWidth, 10) : null;
    } catch (e) {
      return null;
    }
  }

  // Apply the saved width on load (only if user has manually resized before)
  // Use flex-basis instead of width so the panel can still shrink responsively
  const savedWidth = loadLeftPaneWidth();
  if (savedWidth !== null) {
    const constrainedWidth = Math.max(MIN_LEFT_WIDTH, Math.min(MAX_LEFT_WIDTH, savedWidth));
    leftPane.style.flexBasis = constrainedWidth + 'px';
  }
  
  function startResize(e) {
    isResizing = true;
    startX = e.clientX || e.touches[0].clientX;
    startLeftWidth = leftPane.offsetWidth;
    
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    
    // Add overlay to prevent iframe/content interference
    const overlay = document.createElement('div');
    overlay.id = 'resize-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;cursor:col-resize;z-index:9999;';
    document.body.appendChild(overlay);
    
    e.preventDefault();
  }
  
  function doResize(e) {
    if (!isResizing) return;
    
    const currentX = e.clientX || e.touches[0].clientX;
    const deltaX = currentX - startX;
    const newLeftWidth = startLeftWidth + deltaX;
    
    // Calculate available space
    const container = leftPane.parentElement;
    const containerWidth = container.offsetWidth;
    const separatorWidth = separator.offsetWidth;
    const availableWidth = containerWidth - separatorWidth;
    const maxAllowedLeftWidth = Math.min(MAX_LEFT_WIDTH, availableWidth - MIN_RIGHT_WIDTH);
    
    // Constrain the width
    const constrainedWidth = Math.max(MIN_LEFT_WIDTH, Math.min(maxAllowedLeftWidth, newLeftWidth));

    if (constrainedWidth >= MIN_LEFT_WIDTH && constrainedWidth <= maxAllowedLeftWidth) {
      leftPane.style.flexBasis = constrainedWidth + 'px';
    }
    
    e.preventDefault();
  }
  
  function stopResize() {
    if (!isResizing) return;
    
    isResizing = false;
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
    
    // Remove overlay
    const overlay = document.getElementById('resize-overlay');
    if (overlay) {
      overlay.remove();
    }
    
    // Save the final width
    saveLeftPaneWidth(leftPane.offsetWidth);
    
    // Trigger resize event to update other layout elements
    setTimeout(function() {
      if (typeof window.threads_main_resize === 'function') {
        window.threads_main_resize();
      }
    }, 10);
  }
  
  // Mouse events
  separator.addEventListener('mousedown', startResize);
  document.addEventListener('mousemove', doResize);
  document.addEventListener('mouseup', stopResize);
  
  // Touch events for mobile
  separator.addEventListener('touchstart', startResize, { passive: false });
  document.addEventListener('touchmove', doResize, { passive: false });
  document.addEventListener('touchend', stopResize);
  
  // Prevent context menu on separator
  separator.addEventListener('contextmenu', function(e) {
    e.preventDefault();
  });
}

window.open_active_thread_by_link = function(activeThread) {
  //Scroll '#threads_right' to bottom
  let trt = $("#threads_right");
  window.setTimeout(function() {
    if (typeof trt.scrollTo === "function" && trt.length) {
      // trt.scrollTo(trt.get(0).scrollHeight);
      trt.scrollTo({
        top: trt.get(0).scrollHeight,
        // Prevent horizontal scrolling
        left: 0,
        behavior: "smooth"
      });
    }
  }, 200);

  window.update_user_header(activeThread.data("thread-id"));
  
  // Ensure conversation header and message compose box are visible
  $("#threads-right__container > div:first-child").removeClass("hidden");
  $("#threads_right_bottom").removeClass("hidden");
};

window.remove_msg_highlighting = function() {
  if (window.messages_highlighted === 0) return;
  if ($("#single_thread_wrapper").length > 0) {
    $("#conversation").find(".pm_new").removeClass("pm_new");
  } else {
    $("#threads_right").find(".pm_new").removeClass("pm_new");
  }
  window.messages_highlighted = 0;
};

window.get_newest_msg_id_in_thread = function() {
  let lm;
  if ($("#single_thread_wrapper").length > 0) {
    // Classic view
    lm = $("#conversation").find(".pm_msg:first");
  } else {
    // Split view
    lm = $("#threads_right").find(".pm_msg:last");
  }
  if (lm.length) {
    return lm.attr("id").replace("msg_", "");
  }
  return false;
};

window.get_draft = function() {
  let single_thread = $("#single_thread_wrapper").length > 0,
    m = $.trim($("#message").val()),
    res = {},
    at = window.get_active_thread_id(),
    writing_msg = $("#message").is(":focus"),
    // Update draft on server, if user in edit mode & no msg in drafts cache, or it's different.
    update_needed = writing_msg && at && (typeof last_draft[at] == "undefined" || last_draft[at] != m);

  if (update_needed) {
    last_draft[at] = res.message = m;
    // Write info that msg was autosaved
    let currentdate = new Date(),
      txt = "Autosaved at " + formatTimeNow(currentdate);
  }

  return res;
};

// Get active page in classic single thread view
window.get_active_page = function() {
  let c = $("#conversation");
  if (c.length && $.isNumeric(c.data("page"))) return c.data("page");
  return false;
};

// unused?
window.update_pm_info_paged = function() {
  if (window.pm_ajax_request_active) {
    // Run process again in 1 sec
    window.run_update_process(1000);
    return;
  }

  // If not on first page we dont update threads and messages list
  if (window.get_active_page() != 1) {
    window.run_update_process();
    return;
  }

  let stw = $("#single_thread_wrapper"),
    viewing_thread = stw.length > 0,
    tl = $("#threads_left"),
    options = {
      "action": "update_pm_info_paged",
      // TS for user stats
      "ts": window.cur_ts
    };

  if (viewing_thread) {
    // Thread id to get new messages
    options.thread = window.get_active_thread_id();
    // Find newest message
    options.newest_msg_id = window.get_newest_msg_id_in_thread();
    // Save not sent message
    options.draft = window.get_draft();
  } else {
    // max_msg_id to get thread list changes
    options.max_msg_id = tl.data("max-msg-id");
  }

  $.ajax({
    type: "POST",
    url: "/pm.php",
    data: options,
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    if (data?.not_logged_in == 1) {
      window.location.href = window.location.protocol + "//" +
        window.location.hostname + window.location.pathname;
      return;
    }

    // Update member stats if any
    if (typeof data.member_stats != "undefined") {
      window.update_member_stats_messages(data.member_stats);
    }

    let c = $("#conversation");

    if (viewing_thread) {
      // If new messages arrived
      if (typeof data.new_messages != "undefined" && data.new_messages.length > 0) {
        window.messages_highlighted = 1;
        // Remove "new" in 3 seconds
        window.setTimeout(function() {
          window.remove_new_mark();
        }, 3000);

        c.prepend(data.new_messages);
        // If more than 25 msgs - remove
        c.find(".pm_msg:gt(24)").remove();
      }

      // Update "last opened by contact" timestamp
      if (typeof data.lobc != "undefined") {
        /*
         Remove "unread" mark
         Check if timestamp changed
         Microseconds needed
         */
        let l = c.data("lobc");
        // Update only if TS changed
        if (data.lobc > 0 && l < data.lobc) {
          c.data("lobc", data.lobc);
          // Remove unread status
          c.find(".pm_unread").removeClass("pm_unread");
        }
      }
    } else {
      // If threads list changed
      if (data.threads_update && data.max_msg_id) {
        // Update 'max_msg_id'
        tl.data("max-msg-id", data.max_msg_id);
        tl.empty();
        tl.append(data.threads_update);
      }
    }
  }).always(function() {
    // Run again
    window.run_update_process();
  });
};

window.update_pm_info = function() {
  // Don`t run if ajax request is in progress
  // because data can change when ajax request finishes

  /* RUN ONLY FOR 1 TAB ??????  */
  if (window.pm_ajax_request_active) {
    // Run process again in 1 sec
    window.run_update_process(1000);
    return;
  }

  let threadsLeft = $("#threads_left"),
    filtersBlock = $("#filters"),
    filter = filtersBlock.data("filter"),
    newestMsgIdInThread = window.get_newest_msg_id_in_thread();

  $.ajax({
    type: "POST",
    url: "/pm.php",
    data: {
      "action": "update_pm_info",
      // Send this to get new messages
      "thread": window.get_active_thread_id(),
      // Active filter
      "filter": filter,
      // Find newest message
      "newest_msg_id": newestMsgIdInThread,
      // Send this to get thread list changes
      "max_msg_id": threadsLeft.data("max-msg-id"),
      "threads_count": threadsLeft.find(".pm_thread").length,
      // Save not sent message
      "draft": window.get_draft(),
      // TS for user stats
      "ts": window.cur_ts
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    // cast as int
    if (data.not_logged_in == 1) {
      window.location.href = window.location.protocol + "//" +
        window.location.hostname + window.location.pathname;
      return;
    }

    // Update member stats if any
    if (typeof data.member_stats != "undefined") {
      window.update_member_stats_messages(data.member_stats);
    }

    // If threads list changed
    if (data.threads_update && data.max_msg_id) {
      // Update 'max_msg_id'
      threadsLeft.data("max-msg-id", data.max_msg_id);

      let activeThreadId = window.get_active_thread_id();
      let savedScrollTop = threadsLeft[0].scrollTop;
      // Parse new content into a fragment, then swap in one operation to avoid blink
      var tmp = document.createElement('div');
      tmp.innerHTML = data.threads_update;
      var frag = document.createDocumentFragment();
      while (tmp.firstChild) frag.appendChild(tmp.firstChild);
      threadsLeft[0].replaceChildren(frag);
      threadsLeft[0].scrollTop = savedScrollTop;
      requestAnimationFrame(function() { threadsLeft[0].scrollTop = savedScrollTop; });

      if (activeThreadId && $("#thread_" + activeThreadId).length) {
        // If threads was reloaded and there was active thread -
        // set active thread again, without reloading messages
        window.view_thread(activeThreadId, false);
        threadsLeft[0].scrollTop = savedScrollTop;
        setTimeout(function() { threadsLeft[0].scrollTop = savedScrollTop; }, 0);
        setTimeout(function() { threadsLeft[0].scrollTop = savedScrollTop; }, 50);
      }
    }

    let activeThreadId1 = window.get_active_thread_id();
    // Update only if thread_id same
    if (typeof data.thread_id == "undefined" || data.thread_id !== activeThreadId1) return;

    // Update "last opened by contact" timestamp
    if (typeof data.lobc != "undefined") {
      window.update_unread(activeThreadId1, data.lobc, data.new_messages.length);
    }

    // If new messages arrived
    if (data.new_messages) {
      window.messages_highlighted = 1;
      // Remove "new" in 3 seconds
      window.setTimeout(function() {
        window.remove_new_mark();
      }, 3000);

      // Find last date divider
      let threadsRight = $("#threads_right"),
        first_datediv = threadsRight.find(".pm_date_div:last");

      // Append new messages to message list
      window.append_msgs(data.new_messages, threadsRight);

      // Remove dup date dividers
      window.setTimeout(function() {
        // Chk for same date divider in loaded messages
        let date = first_datediv.data("date"),
          last_datediv = $("#threads_right").find("div[data-date=" + date + "]:last");
        if (last_datediv.length > 0) {
          // Remove duplicate old
          last_datediv.remove();
        }
        if (typeof threadsRight.scrollTo === "function" && threadsRight.length) {
          threadsRight.scrollTo({
            top: threadsRight.get(0).scrollHeight,
            // Prevent horizontal scrolling
            left: 0,
            behavior: "smooth"
          });
        }
      }, 200);

    }
  }).always(function() {
    // Run again
    window.run_update_process();
  });
};

window.remove_new_mark = function() {
  if ($("#single_thread_wrapper").length > 0) {
    // Classic view
    $("#conversation").find(".pm_new").removeClass("pm_new");
  } else {
    // Split view
    $("#threads_right").find(".pm_new").removeClass("pm_new");
  }
};

window.update_unread = function(thread_id, lobc, force_check) {
  let thread = $("#thread_" + thread_id);
  force_check = typeof force_check != "undefined";
  // Check if timestamp changed
  // Microseconds needed
  let l = thread.data("lobc");
  // Update only if TS changed OR force_check = true
  if (force_check || (lobc > 0 && l < lobc)) {
    thread.data("lobc", lobc);
    // Remove unread status
    $("#threads_right").find(".pm_unread").removeClass("pm_unread");
  }
};

window.run_update_process = function(interval) {
  if (typeof interval == "undefined") {
    // Run again = function in "interval" after this run finished.
    // We use old online update interval value
    interval = typeof window.online_update_interval == "number" ? window.online_update_interval : 6000;
  }

  const updateFn = window.pm_view_mode === "paged" ? window.update_pm_info_paged : window.update_pm_info;
  window.setTimeout(updateFn, interval);
};

window.add_contact = function() {
  let btn = $("#add_contact"),
    err_txt = "Error when adding new contact. Try again.",
    nc = $("#new_contact"),
    username = $.trim(nc.val());

  if ($("#new_contact:hidden").length) {
    nc.show();
    nc.animate({ "width": "90px", "margin-left": "-4px" }, 100);
    $("#add_contact_link").hide();
    $("#new_contact_button").show();
    return;
  }

  if (username.length < 3 || nc.attr("title") === username) {
    // Avoid double enter press after alert
    nc.blur();
    alert(window.t('common.pm.username_min_length'));
    return false;
  }

  if (!username.length) {
    alert(window.t('common.pm.enter_username'));
    return false;
  }

  btn.prop("disabled", true);

  // Set ajax request marker
  window.pm_ajax_request_active = 1;

  $.ajax({
    type: "POST",
    url: "/pm.php",
    data: {
      "action": "add_contact",
      "username": username
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    if (data.success) {
      // Redirect to new thread
      if (pm_view_mode === "paged") {
        window.location.href = window.location.protocol + "//" +
          window.location.hostname + window.location.pathname +
          "?thread_id=" + data.thread_id;
        return false;
      }
      $("#new_contact").val("");
      // Remove duplicate thread id if any
      $("#thread_" + data.thread_id).remove();
      // Add just rendered thread
      $("#threads_left").prepend(data.body);
      // Make new thread active
      window.view_thread(data.thread_id, true);
    } else {
      if (data.error) {
        alert(data.error);
      } else {
        alert(err_txt);
      }
    }
  }).fail(function(data, textStatus, jqXHR) {
    alert(err_txt);
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
    btn.prop("disabled", false);
  });

  return false;
};

window.get_active_thread_id = function() {
  const re = /thread_id=(\d+)/;
  const rr = re.exec(window.location.href);

  if (rr && typeof rr != "undefined" && typeof rr[1] != "undefined" && $.isNumeric(rr[1])) {
    return rr[1];
  }
  return false;
};

window.get_active_thread_uid = function() {
  let thread = $("#threads_left").find(".pm_thread.active");
  if (thread.length) {
    return thread.data("uid");
  }
  return false;
};

window.navigate_to_report = function(uid) {
  if (window.openReportModal) {
    window.openReportModal('user', uid, uid);
  } else {
    window.location = "/report.php?todo=user&uid=" + uid;
  }
};

window.delete_message = function(id) {
  // Close the dropdown menu after clicking
  $(".msg-actions-menu").addClass("hidden");

  var doDelete = function() {
    var err_txt = window.t('common.pm.delete_message_error');
    var btn = $("#del_msg_btn_" + id),
      tid = window.get_active_thread_id();

    if (!$.isNumeric(tid)) {
      window.location.reload();
      return false;
    }

    var cogrot = $("<i class=\"fa fa-cog cog-rot\"/>");
    btn.hide();
    btn.after(cogrot);

    window.pm_ajax_request_active = 1;
    $.ajax({
      type: "POST",
      url: "/pm.php",
      data: {
        "action": "delete_message",
        "thread": tid,
        "message_id": id
      },
      dataType: "json"
    }).done(function(data, textStatus, jqXHR) {
      if (data.success) {
        $("#msg_" + id).remove();
        if (window.pm_view_mode === "chat") {
          var last = $("#threads_right").children().last();
          if (last.hasClass("pm_date_div")) {
            last.remove();
          }
        }
      } else {
        if (data.error) {
          alert(data.error);
        } else {
          alert(err_txt);
        }
      }
    }).fail(function(data, textStatus, jqXHR) {
      alert(err_txt);
    }).always(function() {
      window.pm_ajax_request_active = 0;
      cogrot.remove();
      btn.show();
    });
  };

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: window.t('common.pm.delete_message_title'),
      message: window.t('common.pm.delete_message_confirm'),
      confirmText: window.t('common.delete'),
      type: 'danger',
      onConfirm: doDelete
    });
  } else {
    if (confirm(window.t('common.pm.delete_message_title') + '\n\n' + window.t('common.pm.delete_message_confirm'))) {
      doDelete();
    }
  }

  return false;
};

window.mark_all_as_read = function() {
  if (!confirm(window.t('common.pm.mark_all_read_confirm'))) return false;

  $.ajax({
    type: "POST",
    url: "/pm.php",
    data: { "action": "mark_all_as_read" },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    // Redirect
    window.location.href = window.location.protocol + "//" +
      window.location.hostname + window.location.pathname;
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
  });
  return false;
};

window.delete_thread = function(t, id, block_user) {
  var isBlock = block_user == 1;
  var title = isBlock
    ? window.t('common.pm.block_user_confirm')
    : window.t('common.pm.delete_conversation_confirm');
  var message = isBlock
    ? window.t('common.pm.block_user_detail')
    : window.t('common.pm.delete_conversation_detail');

  var doDelete = function() {
    var err_txt = window.t('common.pm.delete_thread_error');

    // Hide swipe actions
    $('.thread-swipe-actions').removeClass('translate-x-0').addClass('translate-x-full');

    window.pm_ajax_request_active = 1;
    $.ajax({
      type: "POST",
      url: "/pm.php",
      data: {
        "action": "delete_thread",
        "thread": id,
        "block_user": block_user
      },
      dataType: "json"
    }).done(function(data, textStatus, jqXHR) {
      if (data.success) {
        $("#thread_" + id).remove();
        if (pm_view_mode === "chat") {
          $("#threads_main").removeClass("threads--open");
          if (typeof $.scrollTo === "function" && $(".cCont").length) {
            $.scrollTo($(".cCont"));
          }
          $("#threads_right").empty();
        }
      } else {
        if (data.error) {
          alert(data.error);
        } else {
          alert(err_txt);
        }
      }
    }).fail(function(data, textStatus, jqXHR) {
      alert(err_txt);
    }).always(function() {
      window.pm_ajax_request_active = 0;
    });
  };

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: title,
      message: message,
      confirmText: isBlock ? window.t('legacy.pm.block_user') : window.t('common.delete'),
      type: 'danger',
      onConfirm: doDelete
    });
  } else {
    if (confirm(title + '\n\n' + message)) {
      doDelete();
    }
  }

  return false;
};

window.report_message = function(id) {
  $(".msg-actions-menu").addClass("hidden");

  if (window.openReportModal) {
    const threadUid = window.get_active_thread_uid ? window.get_active_thread_uid() : '';
    window.openReportModal('message', id, threadUid);
  } else {
    const wl = window.location;
    wl.href = wl.protocol + "//" + wl.host + "/report.php?todo=msg&msg_id=" + id + "&thread_id=" + window.get_active_thread_id();
  }
};

// Toggle message actions dropdown
window.toggleMessageActions = function(event, msgId) {
  event.preventDefault();
  event.stopPropagation();
  
  const $menu = $("#msg-actions-" + msgId);
  const $allMenus = $(".msg-actions-menu");
  
  // Close all other menus
  $allMenus.not($menu).addClass("hidden");
  
  // Toggle this menu
  $menu.toggleClass("hidden");
  
  // Position the menu to avoid viewport edges
  if (!$menu.hasClass("hidden")) {
    const button = $(event.currentTarget);
    const buttonRect = button[0].getBoundingClientRect();
    const menuRect = $menu[0].getBoundingClientRect();
    
    // Check if menu would go off the right edge
    if (buttonRect.right - menuRect.width < 0) {
      $menu.css("right", "auto").css("left", "0");
    }
    
    // Check if menu would go off the bottom edge
    if (buttonRect.bottom + menuRect.height > window.innerHeight) {
      $menu.css("top", "auto").css("bottom", "100%");
    }
  }
};

// Message sending functionality has been moved to message-sender.js
// Legacy functions are maintained for backward compatibility

window.focus_msg_box = function() {
  // Focus on msg textarea.
  // For some reason doesn't always work if we do it immediately, so add a timeout.
  window.setTimeout(function() {
    $("#message").focus();
  }, 200);
};

window.load_more_msg = function() {
  let thread_id = window.get_active_thread_id();
  if (!thread_id) return;
  load_more_msg_active = 1;
  window.reload_ads();
  let t = $("#threads_right");
  let container = t[0];

  // Return if no "load more" btn
  if ($("#load_older_messages").length === 0) {
    window.load_more_msg_active = 0;
    return;
  }

  // Find first date divider and message before any DOM changes
  let first_datediv = t.find(".pm_date_div:first");
  let first_msg = t.find(".pm_msg:first");
  let first_msg_id = first_msg.attr("id")?.replace("msg_", "");

  // Hide the load older button instead of removing (to avoid layout shift)
  $("#load_older_messages").css("visibility", "hidden");

  // Set ajax request marker
  window.pm_ajax_request_active = 1;
  $.ajax({
    type: "POST",
    url: "/pm.php",
    data: {
      "action": "load_messages",
      "thread": thread_id,
      "last_msg_id": first_msg_id
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    if (data.body) {
      // Capture scroll position relative to first message
      let firstMsgOffsetBefore = first_msg.length ? first_msg[0].offsetTop : 0;
      let scrollTopBefore = container.scrollTop;

      // Remove load older button and prepend new content
      $("#load_older_messages").remove();
      t.prepend(data.body);

      // Restore scroll position to keep first message in same visual position
      if (first_msg.length) {
        let firstMsgOffsetAfter = first_msg[0].offsetTop;
        container.scrollTop = scrollTopBefore + (firstMsgOffsetAfter - firstMsgOffsetBefore);
      }

      // New msgs can arrive
      window.messages_highlighted = 1;

      // Remove duplicate date dividers and last online markers
      if (!t.find(".no_messages").length) {
        var date = first_datediv.data("date");
        if (t.find("div[data-date=" + date + "]").length > 1) {
          first_datediv.remove();
        }
        var lo = t.find(".msg_last_online");
        if (lo.length > 1) {
          lo[0].remove();
        }
      }
    } else {
      $("#load_older_messages").remove();
      if (data.error) {
        t.prepend(err_div.html(data.error));
      } else {
        t.prepend(err_div.html(err_txt));
      }
    }
  }).fail(function(data, textStatus, jqXHR) {
    $("#load_older_messages").remove();
    t.prepend(err_div.html(err_txt));
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
    window.load_more_msg_active = 0;
  });
  return false;
};

window.threads_main_resize = function() {
  const viewportHeight = window.visualViewport ? window.visualViewport.height : $(window).height();
  const messagesContainer = $(".privateMessages");

  if (messagesContainer.length) {
    // Use viewport-relative geometry to avoid scroll offset shrinking fixed containers.
    const containerRect = messagesContainer.get(0).getBoundingClientRect();
    const bottomNav = document.querySelector('[data-component="mobile-bottom-nav"]');
    const bottomNavHeight = bottomNav ? bottomNav.getBoundingClientRect().height : 0;
    const maxHeight = Math.max(0, viewportHeight - bottomNavHeight);

    // Calculate how much height should be available
    const availableHeight = Math.max(0, maxHeight - Math.max(containerRect.top, 0));

    // Set the max height for message images
    const max_photo_width = ($("#threads_right").width()) - 96;

    // Responsive breakpoints
    const windowWidth = $(window).width();
    const mobileBreakpoint = 900; // Single-pane mode
    const adHideBreakpoint = 1100; // Hide ads when too narrow for 3 panes
    const isMobile = windowWidth < mobileBreakpoint;
    const hideAds = windowWidth < adHideBreakpoint;

    // Check if a thread is currently open
    const isThreadOpen = $("#threads_main").hasClass("threads--open");

    // Check if threads list is empty (showing "No matches" or similar empty state)
    const hasNoThreads = $("#threads_left .pm_thread").length === 0;
    
    // Apply responsive layout styles
    let style = $("<style type='text/css'>" +
      " .privateMessages { height: " + availableHeight + "px !important; }" +
      " .msg_txt IMG, .msg_body IMG { max-width: " + max_photo_width + "px; }" +
      
      // Mobile styles - single pane view
      (isMobile ?
        " @media (max-width: " + mobileBreakpoint + "px) {" +
        // Hide ads on mobile
        "   .privateMessages + div { display: none !important; }" +

        // Hide separator on mobile (single pane view)
        "   #separator { display: none !important; }" +

        // Single pane layout
        "   #threads_main > div:first-child {" +
        "     display: " + (isThreadOpen ? "none" : "flex") + " !important;" +
        "     width: 100% !important;" +
        "     min-width: unset !important;" +
        "     max-width: unset !important;" +
        "   }" +
        "   #threads-right__container {" +
        "     display: " + (isThreadOpen ? "flex" : "none") + " !important;" +
        "     width: 100% !important;" +
        "     min-width: unset !important;" +
        "     max-width: unset !important;" +
        "     border-left: none !important;" +
        "   }" +

        // Add mobile back button when thread is open, hide X button
        (isThreadOpen ?
        "   #mobile-back-btn { display: block !important; }" +
        "   #close_thread_wrap { display: none !important; }" :
        "   #mobile-back-btn { display: none !important; }"
        ) +
        " }"

        // Medium screens - hide ads but keep 2-pane layout (unless no threads)
        : hideAds ?
        " @media (min-width: " + (mobileBreakpoint + 1) + "px) and (max-width: " + (adHideBreakpoint - 1) + "px) {" +
        "   .privateMessages + div { display: none !important; }" +
        (hasNoThreads ?
        // When threads list is empty, expand left panel to full width
        "   #threads_main > div:first-child { display: flex !important; width: 100% !important; min-width: unset !important; max-width: unset !important; }" +
        "   #threads-right__container { display: none !important; }" +
        "   #separator { display: none !important; }"
        :
        "   #threads_main > div:first-child { display: flex !important; min-width: 280px; }" +
        "   #threads-right__container { display: flex !important; min-width: 500px !important; flex: 1; }"
        ) +
        "   #mobile-back-btn { display: none !important; }" +
        "   .privateMessages { width: 100%; }" +
        " }"

        // Wide screens - full 3-pane layout (unless no threads)
        : " @media (min-width: " + adHideBreakpoint + "px) {" +
        (hasNoThreads ?
        // When threads list is empty, expand left panel to full width
        "   #threads_main > div:first-child { display: flex !important; width: 100% !important; min-width: unset !important; max-width: unset !important; }" +
        "   #threads-right__container { display: none !important; }" +
        "   #separator { display: none !important; }" +
        "   .privateMessages + div { display: block !important; }"
        :
        "   #threads_main > div:first-child { display: flex !important; min-width: 280px; }" +
        "   #threads-right__container { display: flex !important; min-width: 500px !important; }" +
        "   .privateMessages + div { display: block !important; }"
        ) +
        "   #mobile-back-btn { display: none !important; }" +
        " }"
      ) +
      "</style>");

    var existing = document.getElementById('js_style');
    if (existing) {
      // Update content in place to avoid removing/re-adding which causes reflow
      existing.textContent = style[0].textContent;
    } else {
      style.attr("id", "js_style").appendTo("head");
    }

    // Direct DOM manipulation for empty threads state (more reliable than CSS)
    if (hasNoThreads && !isThreadOpen) {
      $("#threads_left_container").css({
        "width": "100%",
        "max-width": "none",
        "min-width": "0",
        "flex-basis": "auto",
        "flex-grow": "1"
      });
      $("#threads-right__container").hide();
      $("#separator").hide();
    } else if (!hasNoThreads) {
      // Reset to default styles when threads exist
      $("#threads_left_container").css({
        "width": "",
        "max-width": "",
        "min-width": "",
        "flex-basis": "",
        "flex-grow": ""
      });
      if (!isMobile || isThreadOpen) {
        $("#threads-right__container").show();
      }
      if (!isMobile) {
        $("#separator").show();
      }
    }
  }
  
  // Preserve thread list scroll position across resize-triggered reflows
  var tl = document.getElementById('threads_left');
  if (tl) {
    var savedScroll = tl.scrollTop;
    requestAnimationFrame(function() {
      tl.scrollTop = savedScroll;
    });
  }
  
  // Scroll messages to bottom if thread is open
  const threadsRight = $("#threads_right");
  if (threadsRight.length && $("#threads_main").hasClass("threads--open")) {
    setTimeout(function() {
      if (typeof threadsRight.scrollTo === "function") {
        threadsRight.scrollTo({
          top: threadsRight.get(0).scrollHeight,
          left: 0,
          behavior: "auto"
        });
      }
    }, 50);
  }
};

window.scroll_thread_to_middle = function(thread) {
  const tl = $("#threads_left");
  //Scroll '#threads_left' and put active thread in the middle
  if (typeof tl.scrollTo === "function") {
    // tl.scrollTo(tl.scrollTop + thread.position().top - (tl.height() / 2) + 39, 500);
    tl.scrollTo({
      top: tl.scrollTop + thread.position().top - (tl.height() / 2) + 39,
      // Prevent horizontal scrolling
      left: 0,
      behavior: "smooth"
    });
  }
};

window.update_change_view_link = function(thread_id) {
  // Update "change_view" link
  var view = window.pm_view_mode === "chat" ? "paged" : "chat";
  if (typeof thread_id == "undefined") {
    $("#change_view").attr("href", "/pm.php?view=" + view);
  } else {
    $("#change_view").attr("href", "/pm.php?view=" + view + "&thread_id=" + thread_id);
  }
};


window.update_user_header = function(thread_id) {
  const thread = $("#thread_" + thread_id);
  $("#current_thread_avatar").attr("src", thread.data("thumb"));
  $("#current_thread_username").text(thread.data("name"));
  $("#current_thread_link").attr("href", thread.data("profile-link"));
};

window.view_thread = function(thread_id, reload_messages) {
  window.reload_ads();

  $("#alert_bar").remove();

  var msg = $("#message"),
    tl = $("#threads_left"),
    thread = $("#thread_" + thread_id),
    tm = $("#threads_main"),
    use_browser_cached_draft = typeof last_draft[thread_id] != "undefined",
    localDraft = window.draftStorage.load(thread_id);

  // Preserve thread list scroll — guard against reflow-induced resets
  var tlEl = tl[0];
  var _savedScroll = tlEl ? tlEl.scrollTop : 0;
  function _keepScroll() { if (tlEl) tlEl.scrollTop = _savedScroll; }
  // Run a short-lived interval to continuously restore scroll position
  // across all async reflows (style injection, AJAX DOM updates, etc.)
  if (tlEl && _savedScroll > 0) {
    var _guardCount = 0;
    var _scrollGuard = setInterval(function() {
      tlEl.scrollTop = _savedScroll;
      if (++_guardCount >= 30) clearInterval(_scrollGuard);
    }, 10);
    // Also clear guard if user scrolls manually
    var _clearGuard = function() {
      clearInterval(_scrollGuard);
      tlEl.removeEventListener('wheel', _clearGuard);
      tlEl.removeEventListener('touchmove', _clearGuard);
    };
    tlEl.addEventListener('wheel', _clearGuard, { once: true });
    tlEl.addEventListener('touchmove', _clearGuard, { once: true });
  }

  // If reload_messages is false, we only mark thread as active. Without reset form.

  if (reload_messages) {
    // Make 'send message' smaller and make 'message' textarea empty
    $("#threads_main").removeClass("send");
    msg.val("");
    $("#send_thread_id").val(thread_id);
    // Remove autosaved msg
    $("#markitup_msg").empty();
  }

  // Remove "new" in 3 seconds
  window.setTimeout(function() {
    window.remove_new_mark();
  }, 3000);

  // Restore draft from local storage, in-memory cache, or server (via AJAX below)
  if (reload_messages && (localDraft !== null || use_browser_cached_draft)) {
    var draft = localDraft !== null ? localDraft : last_draft[thread_id];
    msg.val(draft);
    if (draft) {
      $("#threads_main").addClass("send");
    }
    if (window.updateSendButtonState) window.updateSendButtonState();
  }
  // With this class '#threads_right' and 'send message' form will be visible
  tm.addClass("threads--open");
  _keepScroll();
  $("#threads-right__container").removeClass("hidden").addClass("flex");
  _keepScroll();

  // Show the conversation header and message compose box
  $("#threads-right__container > div:first-child").removeClass("hidden");
  $("#threads_right_bottom").removeClass("hidden");
  _keepScroll();

  // Hide any open dropdown menus
  $("#conversation-actions-menu").addClass("hidden");
  $(".thread-actions-menu").addClass("hidden");
  $(".thread-swipe-actions").removeClass("translate-x-0").addClass("translate-x-full");

  // Update responsive layout
  window.threads_main_resize();
  _keepScroll();

  window.update_user_header(thread_id);

  // Remove all old active threads
  tl.find(".pm_thread").removeClass("active");
  // Set new thread as active
  thread.addClass("active");
  _keepScroll();

  // Scroll page to top (use native scrollTo to avoid affecting inner scroll containers)
  if ($(window).height() > 590) {
    window.scrollTo(0, 0);
  }
  _keepScroll();

  window.update_change_view_link(thread_id);

  // If reload_messages is false we only mark thread as active. Without reloading messages.
  if (!reload_messages) return false;

  // Remove new msgs counter
  thread.find(".pm_new_circle").remove();
  // Remove red background
  thread.removeClass("new");

  // Show 'hide thread' button. Remove css class which rendered on server side if any
  var ctw = $("#close_thread_wrap");
  ctw.removeClass("visible");
  ctw.show();

  var c = $("#threads_right");

  // Set ajax request marker
  window.pm_ajax_request_active = 1;
  $.ajax({
    type: "POST",
    url: "/pm.php",
    data: {
      "action": "load_messages",
      "thread": thread_id,
      // Skip server draft if we have local data (including explicit empty)
      "load_draft": (localDraft !== null || use_browser_cached_draft) ? 0 : 1
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    c.empty();
    _keepScroll();
    if (data.body) {
      c.append(data.body);
      _keepScroll();
      // Update "last opened by contact" timestamp
      if (typeof data.lobc != "undefined") {
        thread.data("lobc", data.lobc);
      }
      // Load draft if any
      if (data.draft.length > 0) {
        msg.val(data.draft);
        $("#threads_main").addClass("send");
        msg[0].dispatchEvent(new Event('input'));
      }
      window.setTimeout(function() {
        if (typeof c.scrollTo === "function") {
          // c.scrollTo(c.get(0).scrollHeight);
          c.scrollTo({
            top: c.get(0).scrollHeight,
            // Prevent horizontal scrolling
            left: 0,
            behavior: "smooth"
          });
        }
      }, 200);
    } else {
      if (data.error) {
        c.append(err_div.html(data.error));
      } else {
        c.append(err_div.html("This conversation is currently empty."));
      }
    }
    window.focus_msg_box();
  }).fail(function(data, textStatus, jqXHR) {
    c.empty();
    c.append(err_div.html(err_txt));
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
  });
  return false;
};

window.close_thread = function(no_history) {
  // If html5 history not supported use redirect
  if (!htm5_history_supported) {
    window.location.href = window.location.protocol + "//" +
      window.location.hostname + window.location.pathname;
    return false;
  }

  // Dismiss the virtual keyboard so visualViewport reports the full height
  if (document.activeElement && document.activeElement !== document.body) {
    document.activeElement.blur();
  }

  // Clear keyboard-open state and inline styles from mobile keyboard handling
  var pmContainer = document.querySelector('.privateMessages');
  if (pmContainer) {
    pmContainer.classList.remove('keyboard-open');
    pmContainer.style.removeProperty('height');
    pmContainer.style.removeProperty('top');
  }
  var bottomNav = document.querySelector('[data-component="mobile-bottom-nav"]');
  if (bottomNav) bottomNav.style.display = '';

  window.update_change_view_link();

  let tm = $("#threads_main");
  $("#close_thread_wrap").hide();
  tm.find(".pm_thread").removeClass("active");
  
  // Hide the conversation header and message compose box
  $("#threads-right__container > div:first-child").addClass("hidden");
  $("#threads_right_bottom").addClass("hidden");
  
  // Clear the send thread ID and message input
  $("#send_thread_id").val("");
  $("#message").val("");
  
  // Clear photo upload
  if (window.photoUpload) {
    window.photoUpload.removeAllPhotos();
  }
  
  // Hide any open dropdown menus
  $("#conversation-actions-menu").addClass("hidden");
  $(".thread-actions-menu").addClass("hidden");
  $(".thread-swipe-actions").removeClass("translate-x-0").addClass("translate-x-full");
  
  // Clear the messages area and show empty state
  const threadsRight = $("#threads_right");
  const emptyStateHTML = `
    <div class="flex items-center justify-center h-full text-center flex-1">
      <div class="flex flex-col items-center justify-center max-w-sm px-4">
        <div class="relative w-44 h-36 sm:w-52 sm:h-40 mb-6">
          <img src="/images/favicon.svg" alt="" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 sm:w-24 sm:h-24 drop-shadow-lg" />
          <div class="absolute w-10 h-10 sm:w-12 sm:h-12 top-0 left-4 -rotate-12 bg-blue-100 rounded-xl flex items-center justify-center drop-shadow-md">
            <i data-lucide="message-circle" class="w-5 h-5 sm:w-6 sm:h-6 text-blue-500"></i>
          </div>
          <div class="absolute w-9 h-9 sm:w-11 sm:h-11 top-1 right-4 rotate-12 bg-emerald-100 rounded-xl flex items-center justify-center drop-shadow-md">
            <i data-lucide="smile" class="w-5 h-5 sm:w-6 sm:h-6 text-emerald-500"></i>
          </div>
          <div class="absolute w-10 h-10 sm:w-12 sm:h-12 bottom-0 left-6 rotate-6 bg-amber-100 rounded-xl flex items-center justify-center drop-shadow-md">
            <i data-lucide="globe" class="w-5 h-5 sm:w-6 sm:h-6 text-amber-500"></i>
          </div>
          <div class="absolute w-9 h-9 sm:w-11 sm:h-11 bottom-1 right-6 -rotate-6 bg-purple-100 rounded-xl flex items-center justify-center drop-shadow-md">
            <i data-lucide="heart" class="w-5 h-5 sm:w-6 sm:h-6 text-purple-500"></i>
          </div>
        </div>
        <h3 class="text-xl sm:text-2xl font-bold text-gray-800 mb-2">Your conversations</h3>
        <p class="text-gray-500 text-sm sm:text-base">Pick a chat from the list to start messaging</p>
      </div>
    </div>
  `;
  threadsRight.html(emptyStateHTML);

  // Initialize Lucide icons in the empty state
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  }
  
  // Show the right container but keep it in empty state
  $("#threads-right__container").removeClass("hidden").addClass("flex");
  
  tm.removeClass("threads--open");
  
  // Update responsive layout
  window.threads_main_resize();

  if (typeof no_history != "undefined" && no_history) {
    return false;
  }

  // Push url to html5 history
  let stateObj = { "close_thread": true };
  history.pushState(stateObj, null, "/pm.php");
};

window.reload_ads = function() {
  return; // Don't reload ads here for now (globally applied)
};

window.find_contact = function() {
  const username = $.trim($("#username_filter").val());

  const base_url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;

  if (username.length === 0) {
    window.location.href = base_url;
  } else {
    const filter_url = base_url + "?filter=username&filter_value=" + encodeURIComponent(username);
    window.location.href = filter_url;
  }

  return false;
};

let debounceTimer;
window.debounce_find_contact = function(input) {
  clearTimeout(debounceTimer);

  debounceTimer = setTimeout(function() {
    const prev = input.getAttribute("data-filter-value");

    // Only call find_contact if the value is different from the original filter value
    if ((input.value.length >= 3 || input.value.length === 0) && input.value !== prev) {
      window.find_contact();
      // Update the original value
      input.setAttribute("data-filter-value", input.value);
    }
  }, 500);
};

window.load_older_conversations = function(isManual = false) {
  // If there's no "load more" button, there are no more conversations to load
  if ($("#load_more_conversations").length === 0) {
    return false;
  }
  
  load_more_threads_active = 1;
  window.reload_ads();
  let c = $("#threads_left"),
    a = $("#load_more_conversations"),
    fl = $("#filters");
  
  // Hide the load more button and show the loading spinner
  a.hide();
  $("#threads_loading_spinner").removeClass("hidden");

  // Set ajax request marker
  window.pm_ajax_request_active = 1;

  $.ajax({
    type: "POST",
    url: "/pm.php",
    data: {
      "action": "more_threads",
      "from": c.find(".pm_thread").length,
      "filter": fl.data("filter"),
      "max_msg_id": c.data("max-msg-id"),
      "manual_load": isManual ? "1" : "0"
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    if (data.body) {
      let at_id = window.get_active_thread_id();
      if (data.new_data) {
        c.empty();
      }
      
      // Check if the response contains actual thread content or just "No more conversations" message
      if (data.body.includes("pm_thread")) {
        c.append(data.body);
      } else {
        // Remove any existing "No more conversations" messages
        c.find(".bg-sky-100.border.border-sky-200").remove();
        // If there's no more threads to load, append the message and don't show the button again
        c.append(data.body);
        // Hide the loading spinner
        $("#threads_loading_spinner").addClass("hidden");
        return; // Don't recreate the load more button
      }
      
      // Update max-msg-id to track changes of threads list
      c.data("max-msg-id", data.max_msg_id);
      if (data.new_data && at_id && $("#thread_" + at_id).length) {
        // If threads was reloaded set active thread again,
        // without reloading messages
        window.view_thread(at_id, false);
      }
    } else {
      c.append(err_div);
    }
  }).fail(function(data, textStatus, jqXHR) {
    c.append(err_div);
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
    window.load_more_threads_active = 0;
    // Hide the loading spinner
    $("#threads_loading_spinner").addClass("hidden");
    a.remove();
  });
  return false;
};

window["auto_save_intvl"] = 60000;
window["DraftAutoSave"] = function() {
  $("#saveDraftBtn").trigger("click");
  window.setTimeout("DraftAutoSave()", auto_save_intvl);
};

window["show_msg_history"] = function(t) {
  const tNode = $(t);
  const boxNode = $(tNode.data("target"));
  $.ajax({
    url: tNode.data("url")
  }).done(function(data) {
    boxNode.append(data);
    boxNode.show();
    if (typeof tNode.data("scroll") != "undefined") {
      window.setTimeout(function() {
        $.scrollTo($(tNode.data("scroll")), 800);
      }, 100);
    }
    tNode.remove();
  }).fail(function(jqXHR, textStatus, errorThrown) {
  });
};

$(document).ready(function() {
  if (!(new RegExp("mbox.php|mcompose.php|drafts.php")).test(window.location.href)) {
    return;
  }
  $("#msg").focus(function() {
    $(this).removeClass("MsgTAClp").addClass("MsgTAExp");
  });
  $(".MsgCB").show().removeAttr("checked").click(function() {
    $("#mr_" + $(this).val()).toggleClass("mrSelected");
  });

  // Delete messages via ajax
  $(".delMsgLink").addClass("msgRedX").click(function(e) {
      e.preventDefault();
      $(this).removeClass("msgRedX").addClass("ajx_circ_16");
      ajxDelete(this, $(this).parents(".msgRow"));
    }
  );

  $(".msgSpamLink").addClass("msgSpamIcon");

  // Save draft to drafts.php, update message form's draft_id field with
  // the draft id and add a "saved draft at..." field
  $("#saveDraftBtn").show().click(function(e) {
    e.preventDefault();
    var draft_btn = $(this);
    // Grab some data from message
    var msg_form = $(this).parents("form");
    var msg = msg_form.find("textarea[name='message']").val();
    var sub = msg_form.find("input[name='subject']").val();
    if (msg != "") {
      // Begin the action...
      $(draft_btn).attr("disabled", true).val("Saving...");
      $.ajax({
        type: "POST",
        url: "/drafts.php",
        data: {
          todo: "save",
          to: msg_form.find("input[name='to']").val(),
          message: msg,
          subject: sub,
          draft_id: msg_form.find("input[name='draft_id']").val(),
          in_reply_to_id: msg_form.find("input[name='reply']").val()
        },
        dataType: "json",
        success: function(data) {
          if (data.draft_id !== undefined) {
            msg_form.find("input[name='draft_id']").val(data.draft_id);
            $(draft_btn).attr("disabled", false).val("Save Draft");
            // TODO: get the whole string from drafts.php for multilanguage support
            $("#saveDraftStat").html("Draft saved at " + data.saved);
          } else {
            $("#saveDraftStat").html(data.error);
          }
        }
      });
    }
  });
  // Auto-save the draft every x seconds
  window.setTimeout("DraftAutoSave()", auto_save_intvl);

  // Reply link focuses on reply box
  $("#replLink").addClass("clickable").click(function() {
    $("#msg").focus();
  });
});

// Duplicate document.ready block removed - functionality already exists in main block above

window.update_member_stats_messages = function(member_stats) {
  // Custom setCount function for messages page that uses raw values
  function setCountRaw(stats, rawId, displayId, msg) {
    var rawValue = stats[rawId] || '';
    var currentValue = parseInt($('#' + displayId).text()) || 0;
    var newValue = parseInt(rawValue) || 0;
    
    if (currentValue < newValue) {
      // Generate alert if new total is greater than old total.
      flashTitle('****  ' + msg + '  ****');
      window.title_flash_type = displayId;
    } else if (rawValue == '' && window.title_flash_type == displayId) {
      window.stopFlashTitle();
    }
    
    // Display "99+" for counts greater than 99, otherwise show the actual number
    var displayValue = rawValue;
    if (newValue > 99) {
      displayValue = '99+';
    }
    
    $('#' + displayId).text(displayValue);
  }

  // Use raw counts for display elements
  setCountRaw(member_stats, 'pmNewCnt_raw', 'pmNewCnt', 'New Message');
  setCountRaw(member_stats, 'wpNewCnt_raw', 'wpNewCnt', 'New Wall Post');
  setCountRaw(member_stats, 'frNewCnt_raw', 'frNewCnt', 'New Friend Request');
  setCountRaw(member_stats, 'phNewCnt_raw', 'phNewCnt', 'New Photo Comment');
  setCountRaw(member_stats, 'ncNewCnt_raw', 'ncNewCnt', 'New Note Comment');

  if (window.enable_notifs) {
    window.showNotifications(member_stats.msgs);
  }
  window.cur_ts = member_stats.ts;
};
